import { Link, useLocation } from "react-router-dom";
import { useState } from "react";
import { Menu, X } from "lucide-react";

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  const links = [
    { to: "/", label: "Home" },
    { to: "/#tours", label: "Tours" },
    { to: "/#about", label: "About" },
    { to: "/#faq", label: "FAQ" },
  ];

  return (
    <header
      data-testid="main-navbar"
      className="fixed top-0 left-0 right-0 z-50 backdrop-blur-xl bg-white/70 border-b border-black/5"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 h-16 md:h-20 flex items-center justify-between">
        <Link to="/" data-testid="logo-link" className="font-display font-black text-xl md:text-2xl tracking-tighter">
          YEG SCOOT<span className="text-signal">.</span>
        </Link>

        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <a
              key={l.label}
              href={l.to}
              data-testid={`nav-${l.label.toLowerCase()}`}
              className="text-sm font-medium uppercase tracking-widest text-void/70 hover:text-signal transition-colors duration-200"
            >
              {l.label}
            </a>
          ))}
          <a
            href="/#tours"
            data-testid="nav-book-cta"
            className="bg-void text-white px-6 py-3 text-sm font-bold uppercase tracking-widest hover:bg-signal transition-colors duration-200"
          >
            Book a Ride
          </a>
        </nav>

        <button
          data-testid="mobile-menu-toggle"
          className="md:hidden"
          onClick={() => setOpen(!open)}
          aria-label="Menu"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-black/5 bg-white px-6 py-6 flex flex-col gap-5">
          {links.map((l) => (
            <a
              key={l.label}
              href={l.to}
              onClick={() => setOpen(false)}
              className="text-base font-medium uppercase tracking-widest"
            >
              {l.label}
            </a>
          ))}
          <a
            href="/#tours"
            onClick={() => setOpen(false)}
            className="bg-void text-white px-6 py-4 text-center text-sm font-bold uppercase tracking-widest"
          >
            Book a Ride
          </a>
        </div>
      )}
    </header>
  );
};
